export default class AlertService {
  static showAlert(alertId, message, timeout = 5000) {
    const alert = document.querySelector(alertId);
    if (!alert) {
      console.error(`Alert with id ${alertId} not found`);
    }

    alert.classList.remove("d-none");
    alert.querySelector("div").innerText = message;
    setTimeout(() => {
      alert.classList.add("d-none");
    }, timeout);
  }
}
